module.exports = __webpack_public_path__ + "img/Wp_2023.2a8d73d1.png";